import { CardType, DefaultAudience } from './types'

export const CARD_TYPE_LABEL: Record<CardType, string> = {
  MIXED: 'Mixte',
  NO_CB: 'Sans CB',
  CB_ONLY: 'CB uniquement'
}

export const CARD_TYPE_DETAIL: Record<CardType, string> = {
  MIXED: 'Type de distribution sur carte bancaire et e-bons',
  NO_CB: 'E-bons uniquement',
  CB_ONLY: 'Type de distribution sur carte bancaire uniquement'
}

export const CARD_TYPES: CardType[] = ['MIXED', 'NO_CB', 'CB_ONLY']

export function formatDuration(months: number): string {
  if (months === 12) return '1 an'
  if (months > 0 && months % 12 === 0) {
    const years = months / 12
    return years === 1 ? '1 an' : `${years} ans`
  }
  return `${months} mois`
}

export function audienceLabel(audience: DefaultAudience): string {
  switch (audience) {
    case 'CSE':
      return 'Affecté par défaut aux Clients Pro CSE et apparentés'
    case 'NON_CSE':
      return 'Affecté par défaut aux Clients Pro non CSE'
    case 'ALL':
      return 'Affecté par défaut à tous les Clients Pro'
    default:
      return 'Non affecté par défaut'
  }
}

export function normalizeSearch(value: string): string {
  return (value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

export function cloneData<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T
}

export function plural(count: number, singular: string, pluralForm: string): string {
  return `${count} ${count === 1 ? singular : pluralForm}`
}
